import {assert} from 'assert-ts';
import type {ReviewStatusType} from 'types';
import {ReviewStatuses} from 'types';
import type {Data, DataSimpleValue, DataValue} from 'schemaDefinition/types';

type Visitor = (reviewStatus: ReviewStatusType, path: string) => void;

export const visitReviewStatuses = (
  reviewStatuses: Data,
  visitor: Visitor,
  path?: string,
) => {
  Object.keys(reviewStatuses).forEach(key =>
    visitReviewStatus(
      reviewStatuses[key],
      visitor,
      path ? `${path}.${key}` : key,
    ),
  );
};

const visitReviewStatus = (
  reviewStatus: DataValue,
  visitor: Visitor,
  path: string,
) => {
  if (Array.isArray(reviewStatus)) {
    visitReviewStatusList(reviewStatus, visitor, path);
  } else if (typeof reviewStatus === 'object') {
    visitReviewStatuses(reviewStatus as Data, visitor, path);
  } else {
    const value = reviewStatus as ReviewStatusType;
    assert(
      ReviewStatuses.includes(value),
      'visitReviewStatuses: only valid ReviewStatusType values expected',
    );
    visitor(value, path);
  }
};

const visitReviewStatusList = (
  reviewStatuses: DataSimpleValue[] | Data[],
  visitor: Visitor,
  path: string,
) => {
  // Visit array in reverse order to support deletion
  [...reviewStatuses].reverse().forEach((item, idx) => {
    const subPath = `${path}[${reviewStatuses.length - idx - 1}]`;
    if (typeof item === 'object') {
      visitReviewStatuses(item as Data, visitor, subPath);
    } else {
      visitReviewStatus(item, visitor, subPath);
    }
  });
};
